module.exports = __webpack_public_path__ + "img/excel_pred.273d5568.png";